export default function ProfilePage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <h1 className="text-2xl font-bold">Profile</h1>
      <p>Profile functionality coming soon...</p>
    </div>
  )
}